let codes = {
    Afghanistan: 'af',
    'Åland Islands': 'ax',
    Albania: 'al',
    Algeria: 'dz',
    'American Samoa': 'as',
    AndorrA: 'ad',
    Angola: 'ao',
    Anguilla: 'ai',
    Antarctica: 'aq',
    'Antigua and Barbuda': 'ag',
    Argentina: 'ar',
    Armenia: 'am',
    Aruba: 'aw',
    Australia: 'au',
    Austria: 'at',
    Azerbaijan: 'az',
    Bahamas: 'bs',
    Bahrain: 'bh',
    Bangladesh: 'bd',
    Barbados: 'bb',
    Belarus: 'by',
    Belgium: 'be',
    Belize: 'bz',
    Benin: 'bj',
    Bermuda: 'bm',
    Bhutan: 'bt',
    Bolivia: 'bo',
    'Bosnia and Herzegovina': 'ba',
    Botswana: 'bw',
    'Bouvet Island': 'bv',
    Brazil: 'br',
    'British Indian Ocean Territory': 'io',
    'Brunei Darussalam': 'bn',
    Bulgaria: 'bg',
    'Burkina Faso': 'bf',
    Burundi: 'bi',
    Cambodia: 'kh',
    Cameroon: 'cm',
    Canada: 'ca',
    'Cape Verde': 'cv',
    'Cayman Islands': 'ky',
    'Central African Republic': 'cf',
    Chad: 'td',
    Chile: 'cl',
    China: 'cn',
    'Christmas Island': 'cx',
    'Cocos (Keeling) Islands': 'cc',
    Colombia: 'co',
    Comoros: 'km',
    Congo: 'cg',
    'Congo, The Democratic Republic of the': 'cd',
    'Cook Islands': 'ck',
    'Costa Rica': 'cr',
    "Cote D'Ivoire": 'ci',
    Croatia: 'hr',
    Cuba: 'cu',
    Cyprus: 'cy',
    'Czech Republic': 'cz',
    Denmark: 'dk',
    Djibouti: 'dj',
    Dominica: 'dm',
    'Dominican Republic': 'do',
    Ecuador: 'ec',
    Egypt: 'eg',
    'El Salvador': 'sv',
    'Equatorial Guinea': 'gq',
    Eritrea: 'er',
    Estonia: 'ee',
    Ethiopia: 'et',
    'Falkland Islands (Malvinas)': 'fk',
    'Faroe Islands': 'fo',
    Fiji: 'fj',
    Finland: 'fi',
    France: 'fr',
    'French Guiana': 'gf',
    'French Polynesia': 'pf',
    'French Southern Territories': 'tf',
    Gabon: 'ga',
    Gambia: 'gm',
    Georgia: 'ge',
    Germany: 'de',
    Ghana: 'gh',
    Gibraltar: 'gi',
    Greece: 'gr',
    Greenland: 'gl',
    Grenada: 'gd',
    Guadeloupe: 'gp',
    Guam: 'gu',
    Guatemala: 'gt',
    Guernsey: 'gg',
    Guinea: 'gn',
    'Guinea-Bissau': 'gw',
    Guyana: 'gy',
    Haiti: 'ht',
    'Heard Island and Mcdonald Islands': 'hm',
    'Holy See (Vatican City State)': 'va',
    Honduras: 'hn',
    'Hong Kong': 'hk',
    Hungary: 'hu',
    Iceland: 'is',
    India: 'in',
    Indonesia: 'id',
    'Iran, Islamic Republic Of': 'ir',
    Iraq: 'iq',
    Ireland: 'ie',
    'Isle of Man': 'im',
    Israel: 'il',
    Italy: 'it',
    Jamaica: 'jm',
    Japan: 'jp',
    Jersey: 'je',
    Jordan: 'jo',
    Kazakhstan: 'kz',
    Kenya: 'ke',
    Kiribati: 'ki',
    "Korea, Democratic People'S Republic of": 'kp',
    'Korea, Republic of': 'kr',
    Kuwait: 'kw',
    Kyrgyzstan: 'kg',
    "Lao People'S Democratic Republic": 'la',
    Latvia: 'lv',
    Lebanon: 'lb',
    Lesotho: 'ls',
    Liberia: 'lr',
    'Libyan Arab Jamahiriya': 'ly',
    Liechtenstein: 'li',
    Lithuania: 'lt',
    Luxembourg: 'lu',
    Macao: 'mo',
    'Macedonia, The Former Yugoslav Republic of': 'mk',
    Madagascar: 'mg',
    Malawi: 'mw',
    Malaysia: 'my',
    Maldives: 'mv',
    Mali: 'ml',
    Malta: 'mt',
    'Marshall Islands': 'mh',
    Martinique: 'mq',
    Mauritania: 'mr',
    Mauritius: 'mu',
    Mayotte: 'yt',
    Mexico: 'mx',
    'Micronesia, Federated States of': 'fm',
    'Moldova, Republic of': 'md',
    Monaco: 'mc',
    Mongolia: 'mn',
    Montserrat: 'ms',
    Morocco: 'ma',
    Mozambique: 'mz',
    Myanmar: 'mm',
    Namibia: 'na',
    Nauru: 'nr',
    Nepal: 'np',
    Netherlands: 'nl',
    'Netherlands Antilles': 'an',
    'New Caledonia': 'nc',
    'New Zealand': 'nz',
    Nicaragua: 'ni',
    Niger: 'ne',
    Nigeria: 'ng',
    Niue: 'nu',
    'Norfolk Island': 'nf',
    'Northern Mariana Islands': 'mp',
    Norway: 'no',
    Oman: 'om',
    Pakistan: 'pk',
    Palau: 'pw',
    'Palestinian Territory, Occupied': 'ps',
    Panama: 'pa',
    'Papua New Guinea': 'pg',
    Paraguay: 'py',
    Peru: 'pe',
    Philippines: 'ph',
    Pitcairn: 'pn',
    Poland: 'pl',
    Portugal: 'pt',
    'Puerto Rico': 'pr',
    Qatar: 'qa',
    Reunion: 're',
    Romania: 'ro',
    'Russian Federation': 'ru',
    RWANDA: 'rw',
    'Saint Helena': 'sh',
    'Saint Kitts and Nevis': 'kn',
    'Saint Lucia': 'lc',
    'Saint Pierre and Miquelon': 'pm',
    'Saint Vincent and the Grenadines': 'vc',
    Samoa: 'ws',
    'San Marino': 'sm',
    'Sao Tome and Principe': 'st',
    'Saudi Arabia': 'sa',
    Senegal: 'sn',
    'Serbia and Montenegro': 'cs',
    Seychelles: 'sc',
    'Sierra Leone': 'sl',
    Singapore: 'sg',
    Slovakia: 'sk',
    Slovenia: 'si',
    'Solomon Islands': 'sb',
    Somalia: 'so',
    'South Africa': 'za',
    'South Georgia and the South Sandwich Islands': 'gs',
    Spain: 'es',
    'Sri Lanka': 'lk',
    Sudan: 'sd',
    Suriname: 'sr',
    'Svalbard and Jan Mayen': 'sj',
    Swaziland: 'sz',
    Sweden: 'se',
    Switzerland: 'ch',
    'Syrian Arab Republic': 'sy',
    'Taiwan, Province of China': 'tw',
    Tajikistan: 'tj',
    'Tanzania, United Republic of': 'tz',
    Thailand: 'th',
    'Timor-Leste': 'tl',
    Togo: 'tg',
    Tokelau: 'tk',
    Tonga: 'to',
    'Trinidad and Tobago': 'tt',
    Tunisia: 'tn',
    Turkey: 'tr',
    Turkmenistan: 'tm',
    'Turks and Caicos Islands': 'tc',
    Tuvalu: 'tv',
    Uganda: 'ug',
    Ukraine: 'ua',
    'United Arab Emirates': 'ae',
    'United Kingdom': 'gb',
    'United States': 'us',
    'United States Minor Outlying Islands': 'um',
    Uruguay: 'uy',
    Uzbekistan: 'uz',
    Vanuatu: 'vu',
    Venezuela: 've',
    'Viet Nam': 'vn',
    'Virgin Islands, British': 'vg',
    'Virgin Islands, U.S.': 'vi',
    'Wallis and Futuna': 'wf',
    'Western Sahara': 'eh',
    Yemen: 'ye',
    Zambia: 'zm',
    Zimbabwe: 'zw',
    "San-Marino": "sm",

    "Papua-New-Guinea": "pg",

    "Burkina-Faso": "bf",

    "Falkland-Islands": "fk",

    "Taiwan": "tw",

    "Micronesia": "fm",

    "Faeroe-Islands": "fo",

    "South-Sudan": "ss",

    "Hong-Kong": "hk",

    "Laos": "la",

    "Brunei": "bn",

    "Sint-Maarten": "mf",

    "Turks-and-Caicos": "tc",

    "Solomon-Islands": "sb",

    "Wallis-and-Futuna": "wf",

    "Marshall-Islands": "mh",

    "Vatican-City": "va",

    "Saint-Lucia": "lc",

    "French-Guiana": "gf",

    "Cabo-Verde": "cv",

    "Andorra": "ad",

    "Equatorial-Guinea": "gq",

    "Antigua-and-Barbuda": "ag",

    "Cayman-Islands": "ky",

    "Isle-of-Man": "om",

    "Saint-Martin": "mf",

    "Sao-Tome-and-Principe": "st",

    "British-Virgin-Islands": "vg",

    "Saint-Kitts-and-Nevis": "kn",

    "Cura&ccedil;ao": "cw",

    "Western-Sahara": "eh",

    "Saint-Helena": "sh",

    "Sierra-Leone": "sl",

    "Saint-Pierre-Miquelon": "pm",

    "St-Barth": "bl",

    "Syria": "sy",

    "New-Zealand": "nz",

    "New-Caledonia": "nc",

    "Tanzania": "tz",

    "St-Vincent-Grenadines": "vc",

    "Czechia": "cz",

    "El-Salvador": "sv",

    "Trinidad-and-Tobago": "tt",

    "UAE": "ae",

    "Serbia": "rs",

    "Vietnam": "vn",

    "Saudi-Arabia": "sa",

    "Palestine": "ps",

    "Costa-Rica": "cr",

    "Montenegro": "me",

    "Libya": "ly",

    "Moldova": "md",

    "Bosnia-and-Herzegovina": "ba",

    "North-Macedonia": "mk",

    "Sri-Lanka": "lk",

    "R&eacute;union": "re",

    "Dominican-Republic": "do",

    "Eswatini": "sz",

    "French-Polynesia": "pf",

    "S-Korea": "kr",

    "Rwanda": "rw",

    "Russia": "ru",

    "Iran": "ir",

    "South-Africa": "za",

    "USA": "us",

    "MS-Zaandam-": "",

    "US-Virgin-Islands": "vi",

    "Puerto-Rico": "pr"

  }

  module.exports = codes